"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfirmDialog = void 0;
const tslib_1 = require("tslib");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importStar(require("react"));
const useDialogAnchorGlue_1 = require("./useDialogAnchorGlue");
function useConfirmDialog(params) {
    const [showing, setShowing] = react_1.default.useState(false);
    const { getAnchorClientRect } = (0, useDialogAnchorGlue_1.useDialogAnchorGlue)();
    const resolver = (0, react_1.useRef)();
    const confirm = () => {
        setShowing(true);
        return new Promise((resolve) => {
            resolver.current = resolve;
        });
    };
    const handleNo = () => {
        resolver.current && resolver.current(false);
        setShowing(false);
    };
    const handleYes = () => {
        resolver.current && resolver.current(true);
        setShowing(false);
    };
    if (!params) {
        return {
            Dialog: () => null,
            confirm: () => Promise.resolve(false),
        };
    }
    const { prompt, yes, no } = params, dialogProps = tslib_1.__rest(params, ["prompt", "yes", "no"]);
    const footerContent = (react_1.default.createElement(widgets_1.DialogFooterButtonsWidget, { buttons: [
            Object.assign(Object.assign({ buttonType: widgets_1.ButtonType.Outline }, no), { onClick: handleNo }),
            Object.assign(Object.assign({ buttonType: widgets_1.ButtonType.Destructive }, yes), { onClick: handleYes }),
        ] }));
    const overriddenDialogProps = Object.assign(Object.assign({ testId: 'confirm-dialog', showCloseButton: false, dialogMinWidth: 400, positioningBehavior: widgets_1.DialogPositioningBehavior.Centered, type: widgets_1.DialogType.NormalWithTitleBar }, dialogProps), { footerContent, isModal: true, getAnchorClientRect, onCloseRequest: handleNo, handleGlassClick: handleNo, shouldReturnFocusOnClose: true });
    const Dialog = () => (!showing
        ? null
        : (react_1.default.createElement(widgets_1.DialogWidget, Object.assign({}, overriddenDialogProps),
            react_1.default.createElement("p", null, prompt))));
    return { Dialog, confirm };
}
exports.useConfirmDialog = useConfirmDialog;
//# sourceMappingURL=useConfirmDialog.js.map